import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-104">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.5
    }} className="bg-[#0C0C0C] border border-white/10 rounded-3xl p-8 sm:p-12 relative overflow-hidden" data-id="element-105">
        <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-[80px] -z-10" data-id="element-106" />

        <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-8" data-id="element-107">
          Dejá de mirar videos en youtube y perder tiempo. Empezá a ejecutar con
          un plan.
        </h2>

        <div className="space-y-6 text-lg text-gray-300 font-medium leading-relaxed" data-id="element-108">
          <p data-id="element-109">
            Si estás empezando de cero absoluto, El Código del Dinero es el mapa
            de ejecución que te ahorra años de errores y frustración. Y si ya
            conoces el Dropshipping pero no tienes resultados, este es el
            sistema que te dará la claridad que te faltaba.
          </p>
          <p data-id="element-110">
            Olvídate de "adivinar" qué vender. El Código del Dinero te entrega
            la claridad que te faltaba: un sistema basado en productos de alta
            rotación que resuelven problemas reales.
          </p>
          <p className="text-white/90 border-l-4 border-primary pl-4 py-1" data-id="element-111">
            Si querés hacer{' '}
            <span className="text-accent font-bold" data-id="element-112">$10,000 USD</span> en ventas
            tenés que detectar la demanda de productos que la gente ya está
            buscando desesperadamente y necesita recibir hoy mismo. Y eso
            aprendes en El Código del Dinero.
          </p>
        </div>
      </motion.div>
    </section>;
}